<template>
  <v-slide-x-transition>
    <v-list-tile v-if="feature" class="my-2">
      <v-switch v-model="model" hide-details :label="`Sólo productos sin '${feature.name}'`" />
    </v-list-tile>
  </v-slide-x-transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", ["feature", "onlyMissing"]),
    model: {
      get() {
        return this.onlyMissing;
      },
      set(value) {
        this.setOnlyMissing(value);
      }
    }
  },
  methods: {
    ...mapMutations("featureRules", ["setOnlyMissing"])
  }
};
</script>